// @flow
import * as React from 'react';

const HDivider: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`h-[1px] w-full bg-secondary-background ${className}`} />
);

export default HDivider;
